import ApiService, {ApiPatch, ApiPost} from '../../../../shared/services/api-service';
import commonActionCreators from '../../../../shared/store/common/action-creators';
import oitsCommitTypes from '../commit-types';
import notificationsActionsCreator from "../../notifications/action-creators";
import reportsCommitTypes from "../../reports/commit-types";

const oitsActionCreators = {
  fetchOit(oitGuid) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchOit'));
      const data = await ApiService.get(`/api/v1/oits/${oitGuid}`)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchOit'));
      if (data) {
        dispatch(this.fetchOitSuccess(data));
      }
      return Promise.resolve();
    };
  },
  fetchOitSuccess(oitResponse) {
    return (dispatch) => {
      dispatch(this.replaceOit(oitResponse.data));
    };
  },
  fetchOits(scope, status, coordinator) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchOits'));
      let oitRequest;
      // if (scope === 'fto') {
      //  oitRequest = status==='all' ? '/api/v1/oits' : '/api/v1/my-active-oits';
      //} else {
      if(status && !coordinator) {
        oitRequest = `/api/v1/oits?status=${status}`
      } else if(!status && coordinator) {
        oitRequest = `/api/v1/oits?ftocGuid=${coordinator}`
      } else if(status && coordinator) {
        oitRequest = `/api/v1/oits?status=${status}&ftocGuid=${coordinator}`
      } else {
        oitRequest = '/api/v1/oits'
      }
      // oitRequest = status? `/api/v1/oits?status=${status}`:'/api/v1/oits';
      // oitRequest = coordinator? `/api/v1/oits?ftocGuid=${status}`:oitRequest;
      //}


      const data = await ApiService.get(oitRequest)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchOits'));
      if (data) {
        dispatch(this.fetchOitsSuccess(data));
      }
      return Promise.resolve();
    };
  },

  updateSignActors(signActors, trainingTrackerGuid) {
    return (dispatch) =>
      ApiPatch(`/api/v1/training-trackers/${trainingTrackerGuid}`, {
        signActors
      }).then(res => {
        dispatch({
          trainingTrackerGuid,
          signActors,
          type: oitsCommitTypes.UPDATE_TRAINING_TRACKER
        });
        dispatch(notificationsActionsCreator.addSavedSuccessfully('Changes saved'));
      })
  },

  updateSignActorsForPhase(signActors, phaseGuid) {
    return (dispatch) =>
      ApiPatch(`/api/v1/training-phases/${phaseGuid}`, {
        sign_actors: [
          ...signActors
        ]
      }).then(res => {
        dispatch({
          phaseGuid,
          signActors,
          type: oitsCommitTypes.UPDATE_PHASE_TRAINING_TRACKER
        });
        dispatch(notificationsActionsCreator.addSavedSuccessfully('Changes saved'));
      })
  },

  updateProjectedStartEndDatesForPhase(form, phaseGuid) {
    return (dispatch) =>
      ApiPost(`/api/v1/training-phases/${phaseGuid}/update-projection`, {
        ...form
      }).then(res => {
        console.log(res)
        dispatch({
          phaseGuid,
          projectedDates: {...form},
          type: oitsCommitTypes.UPDATE_PHASE_PROJECTED_DATES
        });
        dispatch(notificationsActionsCreator.addSavedSuccessfully('Changes saved'));
      })
  },

  updateSignActorsForReport(signActors, phaseGuid, guid) {
    return (dispatch) =>
      ApiPatch(`/api/v1/training-phases/${phaseGuid}`, {
        sign_actors: [
          ...signActors
        ]
      }).then(res => {
        dispatch({
          phaseGuid,
          signActors,
          type: oitsCommitTypes.UPDATE_PHASE_TRAINING_TRACKER
        });
        dispatch({
          guid,
          signActors,
          type: reportsCommitTypes.UPDATE_SIGN_ACTORS
        });
        dispatch(notificationsActionsCreator.addSavedSuccessfully('Changes saved'));
      })
  },
  updateHoursForPhase(hours, phaseGuid) {
    return (dispatch) =>
      ApiPatch(`/api/v1/training-phases/${phaseGuid}`, {
        hours
      }).then(res => {
        dispatch({
          phaseGuid,
          hours,
          type: oitsCommitTypes.UPDATE_PHASE_TRAINING_TRACKER
        });
        dispatch(notificationsActionsCreator.addSavedSuccessfully('Changes saved'));
      })
  },
  assignCoordinator(trainingTrackerGuid, userGuid) {
    return (dispatch) =>
      ApiPatch(`/api/v1/training-trackers/${trainingTrackerGuid}`, {
        ftocGuid: userGuid
      }).then(res => {
        dispatch(notificationsActionsCreator.addSavedSuccessfully('Changes saved'));
      })
  },

  fetchOitsSuccess(oitsResponse) {
    return (dispatch) => {
      dispatch(this.pushOits(oitsResponse.data));
    };
  },
  loadOitsContainer(scope,status, coordinator) {
    return (dispatch) => {
      return dispatch(this.fetchOits(scope,status, coordinator));
    };
  },
  startOitTraining(oit, tp) {
    return (dispatch) => {
      return ApiPost(`/api/v1/users/${oit.guid}/training-program`, {trainingProgramGuid: tp.guid})
    }
  },
  addVacation(data) {
    return (dispatch) => {
      return ApiPost(`/api/v1/vacation`, data)
    }
  },
  finishVacation({vacationId, ...data}) {
    return (dispatch) => {
      return ApiPatch(`/api/v1/vacation/${vacationId}`, data)
    }
  },
  pushOits(list) {
    return {
      list,
      type: oitsCommitTypes.PUSH_OITS,
    };
  },
  replaceOit(oit) {
    return {
      oit,
      type: oitsCommitTypes.REPLACE_OIT,
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: oitsCommitTypes.SET_OITS_IS_LOADING,
    };
  },
  setSelectedOitGuid(selectedGuid) {
    return {
      selectedGuid,
      type: oitsCommitTypes.SET_SELECTED_OIT_GUID,
    };
  },
  unmountOitsContainer() {
    return {
      type: oitsCommitTypes.RESET_OITS_STATE,
    };
  },
};

export default oitsActionCreators;
